import { render } from "./AdminNavigation.vue?vue&type=template&id=60fefc38&scoped=true"
import script from "./AdminNavigation.vue?vue&type=script&lang=js"
export * from "./AdminNavigation.vue?vue&type=script&lang=js"

import "./AdminNavigation.vue?vue&type=style&index=0&id=60fefc38&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60fefc38"]])

export default __exports__